import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class SaveUserPostCheckoutAnswer {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * SaveUserPostCheckoutAnswer constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    /**
     * Get list of post checkout questions.
     *
     * @param {String} answer
     *
     * @returns {Boolean}
     */
    async handle(answer) {
        let request = await this.apiService
            .post(ApiEndpoints['users.postcheckout-questions.store'], {
                answer: answer,
            })
            .catch(() => false);

        return request.status === 200;
    }
}
